export enum DateFormat {
    ddMMyyyy = "dd/MM/yyyy",
    mmmDDyyyy = "MMM dd, yyyy",
    mmmmYYYY = "MMMM yyyy",
    ddMMM = "dd MMM",
    mmmDD = "MMM dd",
    mmm = "MMM",
}
